import { render, staticRenderFns } from "./ListTaxes.vue?vue&type=template&id=2937e5cb"
import script from "./ListTaxes.vue?vue&type=script&lang=js"
export * from "./ListTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports